// extracted by mini-css-extract-plugin
export var drawerPaper = "_3u-0";
export var itemCard = "_3u-1";
export var itemImage = "_3u-2";